const t=["google","discord","twitter","github","spotify","instagram","tiktok","linkedin","apple"];export{t as SUPPORTED_OAUTH_PROVIDERS};
